export const LAYOUT_DEFAULT = 'default';
export const LAYOUT_KEYWORDS_ONLY = 'keywords-only';

export const LAYOUT_BATCH_MODE = 'batch-mode';
